import React from 'react';
import classNames from 'classnames';
import s from './RadioButton.module.scss';

interface RadioButtonProps {
  id: string | number;
  Content: string | React.ComponentType;
  fillType?: 'ring' | 'round';
  textColor?: 'primary' | 'white' | 'default';
  radioAlignment?: 'top' | 'middle';
  className?: string;
  radioLabelClass?: string;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string | number,
  ) => void;
  checked?: boolean;
  disabled?: boolean;
  boldLabel?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  Content,
  fillType = 'ring',
  textColor = 'default',
  radioAlignment = 'middle',
  className = '',
  radioLabelClass = '',
  onChange,
  checked = false,
  disabled = false,
  boldLabel,
  ...rest
}) => {
  const radioClasses = classNames(
    s.radioInput,
    s[fillType],
    s[radioAlignment],
    {
      [s.disabled]: disabled,
    },
  );

  const wrapperClasses = classNames(s.radioWrapper, s[textColor], className, {
    [s.boldLabel]: boldLabel,
  });

  return (
    <label className={wrapperClasses}>
      <input
        type="radio"
        value={id}
        checked={checked}
        onChange={(e) => onChange && onChange(e, id)}
        className={radioClasses}
        id={id.toString()}
        disabled={disabled}
        {...rest}
      />
      <div className={s.radioFill} />
      <div className={s.label}>
        {typeof Content === 'string' ? (
          <p className={`${s.text} ${radioLabelClass}`}> {Content} </p>
        ) : (
          <Content />
        )}
      </div>
    </label>
  );
};

export default React.memo(RadioButton);
